// src/pages/nascar/XfOdds.jsx
import React from "react";
import NascarBetting from "./NascarBetting";

export default function XfinityBettingPage() {
  return <NascarBetting series="xfinity" />;
}
